export function normalizeRuPhone(input: string): string | null {
  const digits = input.replace(/\D/g, '');
  let normalized = digits;

  if (normalized.length === 11 && normalized.startsWith('8')) {
    normalized = `7${normalized.slice(1)}`;
  } else if (normalized.length === 10) {
    normalized = `7${normalized}`;
  }

  if (normalized.length !== 11 || !normalized.startsWith('7')) {
    return null;
  }

  return `+${normalized}`;
}

export function isValidRuPhone(input: string): boolean {
  return normalizeRuPhone(input) !== null;
}

/** Форматирует ввод по мере набора: +7 (XXX) XXX-XX-XX */
export function formatPhoneInput(raw: string): string {
  let digits = raw.replace(/\D/g, '');

  if (digits.startsWith('8')) {
    digits = `7${digits.slice(1)}`;
  }
  if (!digits.startsWith('7')) {
    digits = `7${digits}`;
  }

  digits = digits.slice(0, 11);
  const rest = digits.slice(1);

  if (rest.length === 0) return '+7';
  if (rest.length <= 3) return `+7 (${rest}`;
  if (rest.length <= 6) return `+7 (${rest.slice(0, 3)}) ${rest.slice(3)}`;
  if (rest.length <= 8) {
    return `+7 (${rest.slice(0, 3)}) ${rest.slice(3, 6)}-${rest.slice(6)}`;
  }
  return `+7 (${rest.slice(0, 3)}) ${rest.slice(3, 6)}-${rest.slice(6, 8)}-${rest.slice(8, 10)}`;
}
